import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import _ from 'lodash';

// Actions
import { createWarehouse, cleanWarehouses } from "../../../actions/warehouses";
import {getSeries, cleanSeries} from "../../../actions/series";

// Components
import SerieSelector from "../../../components/common/SerieSelector";
import {List} from "immutable/dist/immutable";

class NewWarehouse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            warehouse_code: '',
            name: '',
            comments: '',
            address: ''
        };
    }
    componentDidMount() {
        this.props.getSeries({ document_type: 'warehouse' });
    }
    componentDidUpdate(prevProps, prevState) {
        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue }, this.validateSalesInvoice)
        }
    }
    shouldComponentUpdate(nextProps) {
        return this.state.canSubmit !== nextProps.canSubmit;
    }
    componentWillUnmount() {
        this.props.cleanWarehouses();
        this.props.cleanSeries();
    }

    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            warehouse_code: ''
        }, this.validateWarehouse);
    };

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateWarehouse);
    };

    validateWarehouse = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.warehouse_code !== '') &&
            this.state.name !== '' &&
            this.state.address !== ''
        ) {
            this.setState({
                canSubmit: true
            });
        } else {
            this.setState({
                canSubmit: false
            });
        }
    };

    handleCreateClick = () => {
        this.props.createWarehouse({
            serieSelectedId: this.state.serieSelectedId,
            warehouse_code: this.state.warehouse_code,
            name: this.state.name,
            comments: this.state.comments,
            address: this.state.address
        });
        this.props.history.goBack();
    };

    render() {
        const { canSubmit } = this.state;

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/almacenes">Almacenes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Almacén</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.goBack() }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de Almacén *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.warehouse_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        warehouse_code: event.target.value
                                                                    }, this.validateWarehouse);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Comentarios</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('comments', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Dirección *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('address', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    // Reducers
    const seriesReducer = state.series;

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        series
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createWarehouse: (warehouse) => dispatch(createWarehouse(warehouse)),
        getSeries: (query) => dispatch(getSeries(query)),
        cleanWarehouses: () => dispatch(cleanWarehouses()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewWarehouse);



// WEBPACK FOOTER //
// ./src/containers/configuration/warehouses/NewWarehouse.js